import { generateSrcSet } from './image.generate-src-set.js';

const cache = /* @__PURE__ */ new Map();
function preloadImage(src, sizes, maxImageWidth) {
  const cacheKey = `${src}-${sizes ?? ""}-${maxImageWidth ?? ""}`;
  if (!cache.has(cacheKey)) {
    cache.set(
      cacheKey,
      new Promise((resolve, reject) => {
        const img = new Image();
        img.style.cssText = `
        position: absolute;
        top: -1000px;
        left: -1000px;
        width: 10px;
        height: 10px;
      `;
        img.onload = () => {
          resolve(img);
          img.remove();
        };
        img.onerror = img.onabort = () => {
          reject();
          img.remove();
        };
        img.onabort = () => {
          reject();
          img.remove();
        };
        img.src = src;
        if (sizes) {
          img.srcset = generateSrcSet(src, maxImageWidth);
          img.sizes = sizes;
        }
        document.body.appendChild(img);
      })
    );
  }
  return cache.get(cacheKey);
}
const isImagePreloaded = (src, sizes, maxImageWidth) => {
  return cache.has(`${src}-${sizes ?? ""}-${maxImageWidth ?? ""}`);
};

export { isImagePreloaded, preloadImage };
//# sourceMappingURL=dom.preload-image.js.map
